import { Nullable } from '../Nullable';
import { UnitCarac } from './UnitCarac';
import { Troop } from './Troop';
import { OrganisationChange } from './OrganisationChange';
import { ModelRuleUnitTroop } from './ModelRuleUnitTroop';
import { IEntityId } from '../IEntityId';
import { IConstrainedObject } from '././constraints/iconstrained-object';
import { UnitOptionGroup } from './unit-option-group';
import { IPositionnable } from '../IPositionnable';
import { IPriceable } from '../IPriceable';

export interface Unit
  extends IEntityId<number>,
    IConstrainedObject,
    IPositionnable,
    IPriceable {
  is_desabled: boolean;
  army_id: number;
  principal_organisation_id: number;
  min_size: number;
  max_size: number;
  magic: Nullable<string>;
  notes: Nullable<string>;
  is_mount: boolean;
  type_figurine: number;
  add_value_points: number;
  carac: UnitCarac;
  organisationIds: Array<number>;
  allOrganisationIds: Array<number>;
  armyOrganisationId: Nullable<number>;
  armyOrganisationActivatorId: Nullable<number>;
  troops: Array<Troop>;
  modelRuleUnitTroops: Array<ModelRuleUnitTroop>;
  optionGroups: UnitOptionGroup[];
  organisation_changes: Array<OrganisationChange>;
  unitCategoryId: number;
}

export const sortUnitByPosition = (a: Unit, b: Unit): number =>
  a.position - b.position;
